import React, { forwardRef } from 'react'

import Box, { type BoxProps } from '../box'

// the content column of the login and password screens
export const contentMaxWidth = 480

export type PageProps = BoxProps

const Page = forwardRef<HTMLElement, PageProps>((props, ref) => (
  <Box
    ref={ref}
    alignSelf='center'
    bg='white'
    flex='1 1 auto'
    py='24'
    width='100%'
    maxWidth={contentMaxWidth}
    {...props}
  />
))
Page.displayName = 'Page'

export default Page
